import React, { useContext } from "react";
import Row from "@amzn/meridian/row";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import { FormattedMessage } from "react-intl";
import {
  ASSIGNABLE,
  DEPARTED,
  getRouteCountByStatus,
  getRouteFilterByMetric,
  NOT_READY,
  PENDING_DEPART,
  PENDING_PICK,
  PENDING_STAGE,
} from "../RouteStatusManager";
import Link from "@amzn/meridian/link";
import { getDocumentURL } from "../../handler/ParentDataHandler";
import { OutboundFilterContext } from "../context/OutboundFilterContext";
import { getRouteCodeListForStow, getTargetTabByMetric } from "../util/Util";
import { OutboundConfigContext } from "../context/OutboundConfigContext";
import ScrollableElementWrapper from "../../CommonModels/ScrollableElementWrapper";
import { useDeviceLayout } from "../../common/context/DeviceLayoutContext";

const TabularGridView = (props) => {
  const { spacingInset_shorthand2 } = useDeviceLayout;
  const { viewModelF } = useContext(OutboundFilterContext);
  const { outboundConfigModel } = useContext(OutboundConfigContext);
  let routeList = props.routeList;
  routeList = routeList.sort((a, b) => a.criticalPullTime - b.criticalPullTime);

  const routeWaveList = [];
  routeList.forEach((route) => {
    const wave = routeWaveList.find((wave) => {
      return wave.name === route.routeSLA;
    });
    if (wave) {
      wave.routeList.push(route);
    } else {
      routeWaveList.push({
        name: route.routeSLA,
        routeList: [route],
      });
    }
  });

  const getFiltersUri = (metric, wave) => {
    let filterObj = getRouteFilterByMetric(
      metric,
      viewModelF,
      outboundConfigModel.stationConfig,
    );
    filterObj = {
      xptNodes: viewModelF.xptNodes,
      cluster: viewModelF.cluster,
      driverType: viewModelF.driverType,
      departure: [wave],
      ...filterObj,
    };
    return JSON.stringify(filterObj).replace("/", "%2f");
  };

  const onMetricCountClick = (metric, wave) => {
    const tab = getTargetTabByMetric(metric);
    const filters = getFiltersUri(metric, wave.name);
    getDocumentURL().then((result) => {
      //const result = "https://logistics-preprod.amazon.com/station/dashboard/outboundAMZL";
      const url = new URL(result.replace("outboundAMZL", tab));
      let shareableLink;
      if ("stow" === tab) {
        shareableLink = `/heatmap/${getRouteCodeListForStow(wave.routeList)}`;
      } else {
        shareableLink = `/${tab}/${filters}`;
      }
      url.searchParams.set("shareableLink", shareableLink);
      window.open(url.href, "_parent");
    });
  };

  return (
    <div>
      <Row
        widths={["grid-12"]}
        alignmentVertical="top"
        spacingInset={spacingInset_shorthand2}
      >
        <ScrollableElementWrapper>
          <Table
            showDividers={true}
            showStripes={true}
            headerRows={1}
            spacing="small"
            headerColumns={1}
            stickyHeaderColumn={true}
            fixHeaderRows={true}
          >
            <TableRow>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.stageByTime"
                  defaultMessage="Stage by time"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.totalRoutes"
                  defaultMessage="Total Routes"
                />
              </TableCell>
              {(outboundConfigModel.stationConfig.amxl ||
                outboundConfigModel.stationConfig
                  .drsPickStageVisibilityEnabled) && (
                <TableCell alignmentHorizontal="right">
                  <FormattedMessage
                    id="outboundAMZL.pendingStow"
                    defaultMessage="Pending Stow"
                  />
                </TableCell>
              )}
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.notAssigned"
                  defaultMessage="Not assigned"
                />
              </TableCell>
              {!outboundConfigModel.stationConfig.amxl &&
                !outboundConfigModel.stationConfig.stagenabled && (
                  <TableCell alignmentHorizontal="right">
                    <FormattedMessage
                      id="outboundAMZL.pendingPick"
                      defaultMessage="Pending Pick"
                    />
                  </TableCell>
                )}
              {!outboundConfigModel.stationConfig.amxl && (
                <TableCell alignmentHorizontal="right">
                  <FormattedMessage
                    id="outboundAMZL.pendingStage"
                    defaultMessage="Pending Stage"
                  />
                </TableCell>
              )}
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.pendingDepart"
                  defaultMessage="Pending Depart"
                />
              </TableCell>
              <TableCell alignmentHorizontal="right">
                <FormattedMessage
                  id="outboundAMZL.departed"
                  defaultMessage="Departed"
                />
              </TableCell>
            </TableRow>
            {routeWaveList.map((wave) => (
              <TableRow key={wave.name}>
                <TableCell alignmentHorizontal="right">{wave.name}</TableCell>
                <TableCell alignmentHorizontal="right">
                  {wave.routeList.length}
                </TableCell>
                {(outboundConfigModel.stationConfig.amxl ||
                  outboundConfigModel.stationConfig
                    .drsPickStageVisibilityEnabled) && (
                  <TableCell alignmentHorizontal="right">
                    <Link
                      type={"secondary"}
                      onClick={() => onMetricCountClick(NOT_READY, wave)}
                    >
                      {getRouteCountByStatus(NOT_READY, wave.routeList)}
                    </Link>
                  </TableCell>
                )}
                <TableCell alignmentHorizontal="right">
                  <Link
                    type={"secondary"}
                    onClick={() => onMetricCountClick(ASSIGNABLE, wave)}
                  >
                    {getRouteCountByStatus(ASSIGNABLE, wave.routeList)}
                  </Link>
                </TableCell>
                {!outboundConfigModel.stationConfig.amxl &&
                  !outboundConfigModel.stationConfig.stagenabled && (
                    <TableCell alignmentHorizontal="right">
                      <Link
                        type={"secondary"}
                        onClick={() => onMetricCountClick(PENDING_PICK, wave)}
                      >
                        {getRouteCountByStatus(PENDING_PICK, wave.routeList)}
                      </Link>
                    </TableCell>
                  )}
                {!outboundConfigModel.stationConfig.amxl && (
                  <TableCell alignmentHorizontal="right">
                    <Link
                      type={"secondary"}
                      onClick={() => onMetricCountClick(PENDING_STAGE, wave)}
                    >
                      {getRouteCountByStatus(PENDING_STAGE, wave.routeList)}
                    </Link>
                  </TableCell>
                )}
                <TableCell alignmentHorizontal="right">
                  <Link
                    type={"secondary"}
                    onClick={() => onMetricCountClick(PENDING_DEPART, wave)}
                  >
                    {getRouteCountByStatus(PENDING_DEPART, wave.routeList)}
                  </Link>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                  <Link
                    type={"secondary"}
                    onClick={() => onMetricCountClick(DEPARTED, wave)}
                  >
                    {getRouteCountByStatus(DEPARTED, wave.routeList)}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </ScrollableElementWrapper>
      </Row>
    </div>
  );
};

export default TabularGridView;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/routegridview/TabularGridView.js